/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".header[_ngcontent-%COMP%]{width:100%;position:relative;z-index:1}.header[_ngcontent-%COMP%]   .container-fluid[_ngcontent-%COMP%]{width:100%!important;padding-right:1%!important;padding-left:0!important}.header[_ngcontent-%COMP%]   .logo[_ngcontent-%COMP%]{float:left;cursor:pointer;width:115px!important}.header[_ngcontent-%COMP%]   .sign-in[_ngcontent-%COMP%]{color:#7ebd49;font-weight:500;font-family:Acrom-Medium;cursor:pointer}.header[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]{text-align:right}"];
export { styles as styles };
